import React, { useEffect } from 'react';
import './App.scss';
import './styles/app.scss';
import { Route, Routes } from 'react-router-dom';
import SignIn from './pages/register/SignIn';
import 'bootstrap/dist/css/bootstrap.min.css';
import ForgetPassword from './pages/loginScreens/ForgetPassword';
import ResetPasswordOTP from './pages/loginScreens/ResetPasswordOTP';
import SetNewPassword from './pages/register/SetNewPassword';
import Login from './pages/loginScreens/Login';
import Success from './components/Success';
import { useScrollBlock } from './common/hooks/DisableScroll';
import { UserContextProvider } from './common/contexts/UserContext';
import NotAuthorized from './pages/NotAuthorized';
import PatientsList from './pages/home/PatientsList';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import PrivateRoute from './auth/PriveteRoute';
import About from './pages/home/About';
import Support from './pages/home/Support';
import Settings from './pages/home/Settings';
import Dashboard from './pages/home/Dashboard/Dashboard';
import Sites from './pages/home/Sites';
import Devices from './pages/home/Devices';
import Fota from './pages/home/fota/Fota';
import Users from './pages/home/Users';
import { AlertProvider } from './common/contexts/AlertContext';
import Notifications from './pages/home/Notifications';
import CreateUser from './pages/home/addUser/CreateUser';
import EditUser from './pages/home/addUser/EditUser';
import PatientProfile from './pages/home/PatinetProfile';
import EditPatient from './pages/home/addUser/EditPatient';
import CreateSite from './pages/home/createSite/CreateSite';
import EditSite from './pages/home/createSite/EditSite';
import MainHome from './components/MainHome';
import EditProfile from './pages/profile/EditProfile';
import Documentation from './pages/profile/Documentation';
import DeviceProfile from './components/DeviceProfile/DeviceProfile';
import TermsAndConditions from './pages/register/termsAndConditions/TermsAndConditions';
import { useInactivityLogout } from "./common/contexts/useInactivityLogout";

const queryClient = new QueryClient();

function App() {
  const [blockScroll] = useScrollBlock();
  // useInactivityLogout();
  useEffect(() => {
    blockScroll();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <UserContextProvider>
        <AlertProvider>
          <main className="full-width-height app-main app-background">
            <Routes>
              <Route path="/" element={<Login />} />
              <Route path="Success/:type" element={<Success />} />
              <Route path="NotAuthorized" element={<NotAuthorized />} />
              <Route
                path="/terms-and-conditions"
                element={<TermsAndConditions />}
              />
              <Route path="ResetPasswordOTP" element={<ResetPasswordOTP />} />
              <Route path="ForgotPassword" element={<ForgetPassword />} />
              <Route path="Register">
                <Route path="SignIn/:token" element={<SignIn />} />
                <Route path="SetNewPassword" element={<SetNewPassword />} />
              </Route>
              <Route path="Home" element={<MainHome />}>
                <Route
                  path="Dashboard"
                  element={
                    <PrivateRoute
                      component={Dashboard}
                      componentName="Dashboard"
                    />
                  }
                />
                <Route
                  path="Patients"
                  element={
                    <PrivateRoute
                      component={PatientsList}
                      componentName="Patients"
                    />
                  }
                />
                <Route
                  path="Patients/EditPatient"
                  element={
                    <PrivateRoute
                      component={EditPatient}
                      componentName="EditPatient"
                    />
                  }
                />
                <Route
                  path="Settings"
                  element={
                    <PrivateRoute
                      component={Settings}
                      componentName="Settings"
                    />
                  }
                />
                <Route
                  path="Users"
                  element={
                    <PrivateRoute component={Users} componentName="Users" />
                  }
                />
                <Route
                  path="Users/CreateUser"
                  element={
                    <PrivateRoute
                      component={CreateUser}
                      componentName="CreateUser"
                    />
                  }
                />
                <Route
                  path="Users/EditUser"
                  element={
                    <PrivateRoute
                      component={EditUser}
                      componentName="EditUser"
                    />
                  }
                />
                <Route
                  path="Sites"
                  element={
                    <PrivateRoute component={Sites} componentName="Sites" />
                  }
                />
                <Route
                  path="Sites/CreateSite"
                  element={
                    <PrivateRoute
                      component={CreateSite}
                      componentName="CreateSite"
                    />
                  }
                />
                <Route
                  path="Sites/EditSite"
                  element={
                    <PrivateRoute
                      component={EditSite}
                      componentName="EditSite"
                    />
                  }
                />
                <Route
                  path="Devices"
                  element={
                    <PrivateRoute component={Devices} componentName="Devices" />
                  }
                />
                <Route
                  path="Devices/DeviceProfile"
                  element={
                    <PrivateRoute
                      component={DeviceProfile}
                      componentName="DeviceProfile"
                    />
                  }
                />
                <Route
                  path="Fota"
                  element={
                    <PrivateRoute component={Fota} componentName="Fota" />
                  }
                />
                <Route
                  path="EditProfile"
                  element={
                    <PrivateRoute
                      component={EditProfile}
                      componentName="EditProfile"
                    />
                  }
                />
                <Route
                  path="Documentation"
                  element={
                    <PrivateRoute
                      component={Documentation}
                      componentName="Documentation"
                    />
                  }
                />
                <Route
                  path="PatientProfile"
                  element={
                    <PrivateRoute
                      component={PatientProfile}
                      componentName="PatientProfile"
                    />
                  }
                />
              </Route>
            </Routes>
          </main>
        </AlertProvider>
      </UserContextProvider>
    </QueryClientProvider>
  );
}

export default App;
